import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
            <h1 className="mb-2 text-2xl font-semibold">Algo deu errado</h1>
            <p className="mb-4 text-sm text-muted-foreground">
              Tente recarregar a página. Se o problema persistir, contacte o suporte.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="rounded-md bg-primary px-4 py-2 text-primary-foreground"
            >
              Recarregar
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
